export class ReconnectionStrategy {
  private maxRetries: number
  private baseDelay: number
  private maxDelay: number
  private attempt: number = 0

  constructor(
    maxRetries: number = 10,
    baseDelay: number = 1000,
    maxDelay: number = 16000,
  ) {
    this.maxRetries = maxRetries
    this.baseDelay = baseDelay
    this.maxDelay = maxDelay
  }

  getDelay(): number | null {
    if (this.attempt >= this.maxRetries) {
      return null
    }

    const exponentialDelay = this.baseDelay * Math.pow(2, this.attempt)
    const jitter = Math.random() * 0.1 * exponentialDelay
    const delay = Math.min(exponentialDelay + jitter, this.maxDelay)

    this.attempt++
    return delay
  }

  reset(): void {
    this.attempt = 0
  }

  getAttempt(): number {
    return this.attempt
  }

  canRetry(): boolean {
    return this.attempt < this.maxRetries
  }
}
